import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { ChangelogEntry } from '../../../models/changelog/changelog.model';

@Component({
  selector: 'app-changelog-entry',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './changelog-entry.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./changelog-entry.component.scss'],
})
export class ChangelogEntryComponent {
  @Input() entry!: ChangelogEntry;
  expanded = false;

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  getCategoryLabel(category: string): string {
    switch (category) {
      case 'feature':
        return 'Ny funktion';
      case 'improvement':
        return 'Forbedring';
      case 'bugfix':
        return 'Fejlrettelse';
      default:
        return category;
    }
  }

  getCategoryClass(category: string): string {
    switch (category) {
      case 'feature':
        return 'category-feature';
      case 'improvement':
        return 'category-improvement';
      case 'bugfix':
        return 'category-bugfix';
      default:
        return '';
    }
  }
}
